import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultWallets,
  RainbowKitProvider,
  darkTheme,
  connectorsForWallets,
} from '@rainbow-me/rainbowkit';
import {
  walletConnectWallet,
  injectedWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { configureChains, createClient, WagmiConfig, mainnet } from 'wagmi';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import './App.css';
import { Banner } from './comp/Banner'; //skyface banner logo
import { Home } from './comp/Home';
const alchApi = process.env.REACT_APP_ALCHEMY_KEY;
const projectId = process.env.REACT_APP_PROJ_ID;

const { chains, provider } = configureChains(
  [mainnet],
  [alchemyProvider({ apiKey: alchApi }), publicProvider()]
);

const { wallets } = getDefaultWallets({
  appName: 'SKYFACE MINT',
  projectId,
  chains,
});

const connectors = connectorsForWallets([
  ...wallets,
  {
    groupName: 'WalletConnect',
    wallets: [
      walletConnectWallet({ projectId, chains }),
      injectedWallet({ chains }),
    ],
  },
]);

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

function App() {
  return (
    <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider chains={chains} theme={darkTheme()}>
        <div className='App'>
          <Banner />
          <div>
            <span style={{ color: '#0178db', fontSize: '1.8em' }}>
              Select as many SKYFACEs as you want!
            </span>
            <br></br>
            <span style={{ color: '#0178db', fontSize: '1.8em' }}>
              And receive your higher resolution original NFTs art straight to
              your wallet!
            </span>
            <br></br>
            <span style={{ color: '#0178db', fontSize: '1.2em' }}>
              Current price: only 0.3 ETH per SKYFACE!
            </span>
          </div>
          <div>
            <br></br>
          </div>
          <Home />
        </div>
      </RainbowKitProvider>
    </WagmiConfig>
  );
}
export default App;
